import { useCallback, useMemo } from 'react'
import { researchSessionStore } from 'shared/stores/researchSessionStore'
import { useResearchKodaChat } from './useResearchKodaChat'
import {
	buildResearchKodaActions,
	buildResearchKodaTitle,
} from '../utils/researchKodaPrompts'

export function useResearchKodaBlock(type, cardContext = {}) {
	const draft = researchSessionStore.draftDefaults
	const countries = Array.isArray(draft?.countries) ? draft.countries : []
	const profileCountry =
		draft?.country || (countries.length ? countries[countries.length - 1] : '')
	const profileCareer = draft?.career || ''
	const profileCourse = draft?.course || ''
	const isSelectedCountry = countries.length > 0

	const promptContext = useMemo(() => {
		switch (type) {
			case 'career':
				return {
					career: cardContext.career || profileCareer,
					country: profileCountry,
					isSelectedCountry,
				}
			case 'country':
				return {
					career: profileCareer || cardContext.career,
					country: cardContext.country || profileCountry,
				}
			case 'course':
				return {
					course: cardContext.course || profileCourse,
					country: profileCountry,
					isSelectedCountry,
				}
			default:
				return {}
		}
	}, [
		type,
		cardContext.career,
		cardContext.country,
		cardContext.course,
		profileCareer,
		profileCountry,
		profileCourse,
		isSelectedCountry,
	])

	const { sendPrompt } = useResearchKodaChat()

	const actions = useMemo(
		() => buildResearchKodaActions(type, promptContext),
		[type, promptContext],
	)

	const title = useMemo(
		() => buildResearchKodaTitle(type, promptContext),
		[type, promptContext],
	)

	const onActionClick = useCallback(
		action => {
			if (!action) return
			if (typeof action.onClick === 'function') {
				action.onClick()
				return
			}
			sendPrompt(action.sendText || action.label)
		},
		[sendPrompt],
	)

	return { title, actions, onActionClick }
}
